import React from 'react';
import { Clock, FlaskConical, Radio, TrendingUp } from 'lucide-react';

// Accessible status badge: severity conveyed via icon + label + text, not colour alone.
const ICONS = {
  backlog: Clock,
  piloting: FlaskConical,
  live: Radio,
  scaled: TrendingUp,
};

export default function StatusBadge({ statusKey, label, color, size = 'sm' }) {
  const Icon = ICONS[statusKey] || Clock;
  const pad = size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${pad}`}
      style={{ background: `${color}1A`, color }}>
      <Icon className="w-3.5 h-3.5" aria-hidden="true" />
      {label}
    </span>
  );
}
